import React, { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";
import store from "@/redux/store";
import {storeCalenderSettings, setSelectedDate, getTasks, setSelectedUsers} from '@/reducers/CommunicationCycle';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  EllipsisHorizontalIcon,
} from '@heroicons/react/20/solid'
import { LockClosedIcon } from '@heroicons/react/20/solid'


import { CogIcon } from '@heroicons/react/20/solid'
import { open, close, setPos } from '@/reducers/Window'
import {WINDOW} from "@/actions/globalConst";

import { useTranslation, withTranslation, Trans } from "react-i18next";
import CalenderHelperClass from '@/helpers/CalenderHelper'
import moment from 'moment';

import {DayHeader} from './DayView/DayHeader'
import PPCEvent, { WINDOW_EVENTS } from '@/Events/Event'

export function DayView({...props}) {
    const [uid, setUID] = useState(uuid());
    const { t, i18n, ready } = useTranslation();
    const [dayItems, setDayItems] = useState();
    const [calenderType, setCalenderType] = useState( (props?.calenderSettings && props?.calenderSettings?.viewtype) ? props?.calenderSettings?.viewtype : 0 );

    const [currentDate, setCurrentDate] = useState(((props?.selectedDate) ? props.selectedDate : moment()));
    let days = CalenderHelperClass.getDaysForMonth(currentDate, moment().add( (props?.maxMonths) ? props?.maxMonths : 6 , 'months') ,true);
    let monthHeader = null;
    
    const setCalenderTypeEventHandler=(event, type) => {
        event.preventDefault();
        store.dispatch( storeCalenderSettings({viewtype:type}) )
//        setCalenderType(type);
        return false;
    }

    useEffect(() => {
      window.addEventListener("resize", windowIsLoaded);
      //window.addEventListener(WINDOW_EVENTS.LOADED, windowIsLoaded)
      windowIsLoaded(null);
      return () => {
          window.removeEventListener("resize", windowIsLoaded);
        //  window.removeEventListener(WINDOW_EVENTS.LOADED, windowIsLoaded);
          }
    }, []);      

    const windowIsLoaded = (event) => {
        let windowLoaded = document.getElementById(uid);
        if(windowLoaded) {
            let mainContentPanel = document.getElementById('mainContent');
            
            if(windowLoaded && windowLoaded.offsetTop) {
                let newHeight = (document.body.offsetHeight - windowLoaded.offsetTop) - mainContentPanel.offsetTop;

                let parent = windowLoaded.parentElement.parentElement;
                let panelRect = mainContentPanel.getBoundingClientRect();
                newHeight = document.body.offsetHeight - windowLoaded.offsetTop - (80+200);
                //newHeight = (panelRect.height - panelRect.top) - windowLoaded.getBoundingClientRect().top;
                //
                windowLoaded.style.height = newHeight+"px";
                windowLoaded.style.maxHeight = newHeight+"px";
                
                let currentDayKey = CalenderHelperClass.getDayKeyForDate();
                let currentDayElement = document.getElementById("dayPanel_"+currentDayKey);
                if(currentDayKey && ( currentDayElement )) {
                    windowLoaded.scrollTo({
                      top: currentDayElement.offsetTop,
                      left: 0,
                      behavior: "smooth",
                    });                    
                }
            }
            
            
        }
      
      return false;
    }    

    const onSelectedDayEvent = (event, item) => {
        if(item.type == 1) {
            store.dispatch( open({...WINDOW.TODO_WINDOW, data: item}) );
        } else if(item.type == 2) {
            store.dispatch( open({...WINDOW.CONTACT_WINDOW, data: item}) );
        } else if(item.type == 3) {
            store.dispatch( open({...WINDOW.APPOINTMENT_WINDOW, data: item}) );
        }

        return false;
    }
    
    const getBaseView = () => {
        return (
        <nav aria-label="Directory" className="h-full overflow-y-auto min-h-96 " id={uid}>
          {days.map((letter, index) => (
            <div key={letter.month} className="relative">
              <div className="sticky top-0 z-10 border-y border-t-gray-100 border-b-gray-200 bg-gray-50 px-3 py-1.5 text-sm/6 font-semibold text-gray-900">
                <h3>{letter.month}</h3>
              </div>
              <ul role="list" className="divide-y divide-gray-100">
                {letter.dates.map((day) => {
                    let dayItems = null;
                    if(props?.items && props?.items.has(day.key)) {
                        dayItems = props?.items.findOne(day.key, "uid");
                    }
                    
                  return (<li key={day.day} className="flex gap-x-4 px-3 py-5" id={"dayPanel_"+day.key}>
                    <div className="min-w-0">
                      <p className="text-sm/6 font-semibold text-gray-900">{day.day}</p>
                    </div>
                        <div className="flex flex-col w-full">
                    {dayItems && dayItems.items.length > 0 && dayItems.items.map((dayItem) => {
                        if(dayItem.type == 21) {

                            return (
                                <div className={"flex cursor-pointer  w-full mb-1 px-2 pt-1 dayItem eventtype_"+ dayItem.type +" flex-col"} 
                                onClick={(event) => { onSelectedDayEvent(event, dayItem) }}
                                >
                                <div className="grid grid-cols-12">
                                    <div className={"col-span-11 flex flex-row contentPanel"+ ((!CalenderHelperClass.canEdit(dayItem))? " locked" : "")}>
                                        <dd>Hoofdtaak: </dd>
                                        <span className="lblPanel">
                                        {(dayItem) ? dayItem.name : "?"} 
                                        </span>
                                    </div>
                                    <div className={"col-span-1 flex flex-row-reverse"}>
                                    { (CalenderHelperClass.canEdit(dayItem)) &&
                                        <LockClosedIcon className="eventLocked self-center size-4 col-span-1"/>
                                        }
                                    </div>
                                                                    
                                </div>
                                <div className="grid grid-cols-12">
                                    <div className="flex flex-row contentPanel col-span-11">
                                        <span className="block w-full col-span-11 ">{"Dossier: " + ((dayItem && dayItem?.dname) ? dayItem?.dname : 'GEEN TITEL')}</span>
                                        {dayItem && dayItem?.dossier && dayItem?.dossier?.name && 
                                        <span className="block w-full text-xs">{dayItem['dossier']['name']}</span>
                                        }
                                    </div>
                                </div>
                                </div>
                                );
                            
                                                            
                        } else {
                        
                        return (
                            <div className={"flex cursor-pointer  w-full mb-1 px-2 pt-1 dayItem eventtype_"+ dayItem.type +" flex-col"} 
                            onClick={(event) => { onSelectedDayEvent(event, dayItem) }}
                            >
                                <span className="block w-full">{((dayItem && dayItem?.name) ? dayItem?.name : 'GEEN TITEL')}</span>
                                {dayItem && dayItem?.dossier && dayItem?.dossier?.name && 
                                <span className="block w-full text-xs">{dayItem['dossier']['name']}</span>
                                }
                            </div>
                            );
                            }
                    })}
                          </div>
                  </li>
                )})}
              </ul>
            </div>
          ))}
        </nav>   
        )
    }
    
    
    if(props?.baseView) {
        
        return getBaseView();
        
    }
    
    
    return (
        <div className="mt-8 flow-root relative grid grid-cols-12">
            <div className="inset-y-0 left-0 max-lg:w-full row-span-4 col-span-4">

            {!props?.nochange && 
            <Menu as="div" className="relative">
              <MenuButton
                type="button"
                className="flex items-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              >
                {t('calender.viewtype_'+calenderType)}
                <ChevronDownIcon className="-mr-1 size-5 text-gray-400" aria-hidden="true" />
              </MenuButton>

              <MenuItems
                transition
                className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 0)}
                    className="w-full text-left block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_0')}
                  </button>
                </MenuItem>
                <MenuItem>
                  <button
                    onClick={(event) => setCalenderTypeEventHandler(event, 1)}
                    className="w-full text-left block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                  >
                    {t('calender.viewtype_1')}
                  </button>
                </MenuItem>
                </div>
              </MenuItems>
            </Menu>
            }
            
            {getBaseView()}
            
           </div>
        </div>        
        
    )
}